import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: ReactNode;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看更多',
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
            <i className={`${icon} text-lg`} />
          </span>
        )}
        <div>
          <h2 className="text-lg font-bold tracking-tight text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}